const namespace = 'filters';

export const SET_FILTERS = `${namespace}/Set`;
export const RESET_FILTERS = `${namespace}/Reset`;
